import React, {useCallback} from 'react';

import {ClubBody, CreateOrEditClub, ReferenceListBodySkeleton} from "@/components";
import {useLanguage} from "@/contexts/languageContext";
import {ReferenceList} from "@/routes/list/ReferenceList";

export const ClubList = () => {
    const {t} = useLanguage();

    /** La facette `division` est enrichie par l'API avec l'entité division */
    const getFilters = useCallback((facetDistribution) => ({
        division: {
            placeholder: t('sentences.actionField', {action: t('actions.filterBy'), element: t('fields.division')}),
            items: Object.keys(facetDistribution?.division ?? {})
                .map((key) => {
                    const facet = facetDistribution.division[key];
                    return {
                        label: `${facet?.entity?.label ?? key} (${facet?.records ?? 0})`,
                        value: parseInt(key, 10),
                    };
                })
                .sort((a, b) => a.label.localeCompare(b.label)),
        },
    }), [t]);

    return <ReferenceList
        entity="club"
        Body={ClubBody}
        BodySkeleton={ReferenceListBodySkeleton}
        EditBody={CreateOrEditClub}
        getFilters={getFilters}
    />;
};

export default ClubList;
